import { salesLeadFragment } from './salesLeads';

export const companyContactFragment = `
  id
  lastActivityDate
  lastBuiltDate
  createdAt
  verifiedIdGranted
  verifiedIdGrantedAt
  verifiedFinancialGranted
  verifiedFinancialGrantedAt
  verifiedHomeGranted
  verifiedHomeGrantedAt
  stage
  airMilesRewardNumber
  leadSource
  salesLead {
    ${salesLeadFragment}
  }
  affordability @include(if: $withAffordability) {
    maxHomeAffordability
    assessedAt
    monthlyMortgagePayment
    maxRentingAmount
    annualIncome
  }
  marketingConsentGranted
  insightsGeneratedAt
  hubSpotContactId
  hubSpotSyncedAt
`;
